var _style, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1427.49 659",
    style: {
      enableBackground: "new 0 0 1427.49 659"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D5A983;stroke:#D5A983;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_00000102543683002538104160000007274043117875649163_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M625.91,571.21l-4.12-10.75h-16.32l-4.17,10.75h-2.01l14.31-37.02l14.36,37.02H625.91z M613.61,539.43 l-7.33,18.98h14.67L613.61,539.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M632.28,571.21v-35.87h2.01v35.87H632.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M663.73,565.79c-3.01,3.62-6.94,5.42-11.8,5.42h-11.95v-35.87h11.95c4.82,0,8.74,1.8,11.76,5.42 c2.85,3.38,4.27,7.53,4.27,12.45C667.94,558.19,666.53,562.37,663.73,565.79z M662.22,542.19c-2.61-3.22-6.04-4.82-10.3-4.82h-9.94 v31.79h9.94c3.68,0,6.88-1.37,9.59-4.12c2.91-2.95,4.37-6.88,4.37-11.8C665.88,548.85,664.66,545.16,662.22,542.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M673.06,571.21v-35.87h17.22v2.05h-15.16v13.06h15.17v2.22h-15.17v16.47h15.17v2.05h-17.24V571.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M709.48,558.95v-2.05h10.59v2.05H709.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M765.68,571.21l-4.12-10.75h-16.32l-4.17,10.75h-2.01l14.31-37.02l14.36,37.02H765.68z M753.38,539.43 l-7.33,18.98h14.67L753.38,539.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M786.11,570.9c-1.3,0.47-2.85,0.71-4.62,0.71c-5.49,0-9.03-2.6-10.59-7.78l2.05-0.71 c1.17,4.28,4.02,6.43,8.54,6.43c2.59,0,4.61-0.64,6.07-1.91c1.51-1.3,2.26-3.22,2.26-5.73c0-2.38-0.89-4.36-2.66-5.92 c-0.47-0.43-1.18-0.92-2.16-1.46c-0.97-0.53-2.22-1.14-3.72-1.8c-2.85-1.27-4.79-2.38-5.82-3.31c-1.74-1.51-2.61-3.5-2.61-5.98 c0-2.48,0.89-4.48,2.66-5.98c1.74-1.54,3.88-2.3,6.43-2.3c4.22,0,7.19,1.58,8.94,4.73l-1.96,0.86c-0.66-1.11-1.48-1.92-2.41-2.47 c-1.17-0.74-2.69-1.11-4.56-1.11c-1.98,0-3.62,0.55-4.92,1.65c-1.4,1.17-2.11,2.72-2.11,4.62c0,1.71,0.74,3.21,2.22,4.48 c0.84,0.66,2.51,1.58,5.02,2.72c1.58,0.71,2.92,1.4,4.06,2.08c1.14,0.68,2.05,1.39,2.76,2.08c1.93,1.91,2.91,4.28,2.91,7.13 C791.89,566.47,789.97,569.47,786.11,570.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M812.39,570.9c-1.3,0.47-2.85,0.71-4.62,0.71c-5.49,0-9.03-2.6-10.59-7.78l2.05-0.71 c1.17,4.28,4.02,6.43,8.54,6.43c2.59,0,4.61-0.64,6.07-1.91c1.51-1.3,2.26-3.22,2.26-5.73c0-2.38-0.89-4.36-2.66-5.92 c-0.47-0.43-1.18-0.92-2.16-1.46c-0.97-0.53-2.22-1.14-3.72-1.8c-2.85-1.27-4.79-2.38-5.82-3.31c-1.74-1.51-2.61-3.5-2.61-5.98 c0-2.48,0.89-4.48,2.66-5.98c1.74-1.54,3.88-2.3,6.43-2.3c4.22,0,7.19,1.58,8.94,4.73l-1.96,0.86c-0.66-1.11-1.48-1.92-2.41-2.47 c-1.17-0.74-2.7-1.11-4.56-1.11c-1.98,0-3.62,0.55-4.92,1.65c-1.4,1.17-2.11,2.72-2.11,4.62c0,1.71,0.74,3.21,2.22,4.48 c0.84,0.66,2.51,1.58,5.02,2.72c1.57,0.71,2.92,1.4,4.06,2.08c1.14,0.68,2.05,1.39,2.76,2.08c1.94,1.91,2.91,4.28,2.91,7.13 C818.16,566.47,816.23,569.47,812.39,570.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M822.77,571.21v-35.87h2.01v35.87H822.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M844.37,570.9c-1.3,0.47-2.85,0.71-4.62,0.71c-5.49,0-9.03-2.6-10.59-7.78l2.05-0.71 c1.17,4.28,4.02,6.43,8.54,6.43c2.59,0,4.61-0.64,6.07-1.91c1.51-1.3,2.26-3.22,2.26-5.73c0-2.38-0.89-4.36-2.66-5.92 c-0.47-0.43-1.18-0.92-2.16-1.46c-0.97-0.53-2.22-1.14-3.72-1.8c-2.85-1.27-4.79-2.38-5.82-3.31c-1.74-1.51-2.61-3.5-2.61-5.98 c0-2.48,0.89-4.48,2.66-5.98c1.74-1.54,3.88-2.3,6.43-2.3c4.22,0,7.19,1.58,8.94,4.73l-1.96,0.86c-0.66-1.11-1.48-1.92-2.41-2.47 c-1.17-0.74-2.69-1.11-4.56-1.11c-1.98,0-3.62,0.55-4.92,1.65c-1.4,1.17-2.11,2.72-2.11,4.62c0,1.71,0.74,3.21,2.22,4.48 c0.84,0.66,2.51,1.58,5.02,2.72c1.58,0.71,2.92,1.4,4.06,2.08c1.14,0.68,2.05,1.39,2.76,2.08c1.94,1.91,2.91,4.28,2.91,7.13 C850.14,566.47,848.22,569.47,844.37,570.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M863.16,537.42v33.8h-2.05v-33.8h-7.93v-2.05h17.93v2.05H863.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M896.41,571.21l-4.12-10.75h-16.32l-4.17,10.75h-2.01l14.31-37.02l14.36,37.02H896.41z M884.1,539.43 l-7.33,18.98h14.67L884.1,539.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M904.8,540.77v30.43h-2.01v-36.12l26.77,31.39v-31.14h2.05v36.46L904.8,540.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M967.22,569.1c-1.88,1.37-4.42,2.22-7.64,2.51c-0.37,0.03-0.77,0.06-1.21,0.07c-0.43,0.01-0.89,0.03-1.36,0.03 c-5.42,0-9.84-1.71-13.26-5.13c-3.44-3.44-5.17-7.89-5.17-13.31c0-5.42,1.71-9.84,5.13-13.26c3.44-3.44,7.89-5.17,13.31-5.17 c3.07,0,5.86,0.46,8.33,1.36c1.48,0.58,2.9,1.39,4.27,2.47v2.56c-1.4-1.17-2.95-2.11-4.62-2.81c-2.54-1.03-5.2-1.55-7.99-1.55 c-4.76,0-8.67,1.54-11.76,4.62c-3.07,3.09-4.62,7.02-4.62,11.8s1.52,8.7,4.56,11.76c3.07,3.07,7.02,4.62,11.8,4.62 c2.98,0,5.57-0.53,7.78-1.61c1.27-0.64,2.88-1.65,4.82-3.06v2.36L967.22,569.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M973.85,571.21v-35.87h17.22v2.05h-15.17v13.06h15.17v2.22h-15.17v16.47h15.17v2.05h-17.22V571.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1010.27,558.95v-2.05h10.59v2.05H1010.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1066.46,571.21l-4.12-10.75h-16.32l-4.17,10.75h-2.01l14.31-37.02l14.36,37.02H1066.46z M1054.15,539.43 l-7.33,18.98h14.67L1054.15,539.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1090.67,569.25c-1.85,1.54-4.27,2.3-7.28,2.3c-2.91,0-5.35-0.78-7.28-2.36c-2.04-1.71-3.06-4.02-3.06-6.93 v-26.91h2.01v26.91c0,2.3,0.84,4.12,2.51,5.42c1.54,1.21,3.49,1.8,5.82,1.8c2.3,0,4.25-0.62,5.82-1.86 c1.71-1.34,2.56-3.13,2.56-5.38v-26.91h2.05v26.91C1093.83,565.19,1092.78,567.51,1090.67,569.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1123.21,565.79c-3.01,3.62-6.94,5.42-11.8,5.42h-11.95v-35.87h11.95c4.82,0,8.74,1.8,11.76,5.42 c2.85,3.38,4.27,7.53,4.27,12.45C1127.43,558.19,1126.03,562.37,1123.21,565.79z M1121.7,542.19c-2.61-3.22-6.04-4.82-10.3-4.82 h-9.94v31.79h9.94c3.68,0,6.88-1.37,9.59-4.12c2.91-2.95,4.37-6.88,4.37-11.8C1125.37,548.85,1124.15,545.16,1121.7,542.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1132.56,571.21v-35.87h2.01v35.87H1132.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1148.78,537.42v33.8h-2.05v-33.8h-7.93v-2.05h17.93v2.05H1148.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1179.81,552.53v18.69h-2.01v-35.87h15.57v2.05h-13.56v13.06h13.56v2.05h-13.56V552.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1199,571.21v-35.87h2.01v35.87H1199z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1230.43,565.79c-3.01,3.62-6.94,5.42-11.8,5.42h-11.95v-35.87h11.95c4.82,0,8.74,1.8,11.76,5.42 c2.85,3.38,4.27,7.53,4.27,12.45C1234.66,558.19,1233.24,562.37,1230.43,565.79z M1228.93,542.19c-2.61-3.22-6.04-4.82-10.3-4.82 h-9.94v31.79h9.94c3.68,0,6.88-1.37,9.59-4.12c2.91-2.95,4.37-6.88,4.37-11.8C1232.59,548.85,1231.38,545.16,1228.93,542.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1257.3,569.25c-1.85,1.54-4.27,2.3-7.28,2.3c-2.91,0-5.35-0.78-7.28-2.36c-2.04-1.71-3.06-4.02-3.06-6.93 v-26.91h2.01v26.91c0,2.3,0.84,4.12,2.51,5.42c1.54,1.21,3.49,1.8,5.82,1.8c2.3,0,4.25-0.62,5.82-1.86 c1.71-1.34,2.56-3.13,2.56-5.38v-26.91h2.05v26.91C1260.47,565.19,1259.42,567.51,1257.3,569.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1296.12,569.1c-1.88,1.37-4.42,2.22-7.64,2.51c-0.37,0.03-0.77,0.06-1.21,0.07 c-0.43,0.01-0.89,0.03-1.36,0.03c-5.42,0-9.84-1.71-13.26-5.13c-3.44-3.44-5.17-7.89-5.17-13.31c0-5.42,1.71-9.84,5.13-13.26 c3.44-3.44,7.89-5.17,13.31-5.17c3.07,0,5.86,0.46,8.33,1.36c1.48,0.58,2.9,1.39,4.27,2.47v2.56c-1.4-1.17-2.95-2.11-4.62-2.81 c-2.54-1.03-5.2-1.55-7.99-1.55c-4.76,0-8.67,1.54-11.76,4.62c-3.07,3.09-4.62,7.02-4.62,11.8s1.52,8.7,4.56,11.76 c3.07,3.07,7.02,4.62,11.8,4.62c2.98,0,5.57-0.53,7.78-1.61c1.27-0.64,2.88-1.65,4.82-3.06v2.36L1296.12,569.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1302.76,571.21v-35.87h2.01v35.87H1302.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1337.97,571.21l-4.12-10.75h-16.32l-4.17,10.75h-2.01l14.31-37.02l14.36,37.02H1337.97z M1325.67,539.43 l-7.33,18.98h14.67L1325.67,539.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1344.34,571.21v-35.87h2.01v35.87H1344.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1369.3,571.21l-11.4-17.93h-3.86v17.93h-2.01v-35.87h8.29c1.34,0,2.61,0.19,3.81,0.58 c1.21,0.38,2.25,0.96,3.12,1.71c0.87,0.75,1.57,1.68,2.08,2.79s0.78,2.38,0.78,3.81c0,1.58-0.25,2.92-0.72,4.06 c-0.49,1.14-1.17,2.08-2.05,2.81c-0.89,0.74-1.94,1.29-3.13,1.62c-1.21,0.35-2.53,0.53-3.97,0.53l11.51,17.93h-2.44V571.21z  M1367.4,541.2c-0.4-0.86-0.96-1.55-1.65-2.11c-0.71-0.55-1.52-0.97-2.47-1.26c-0.93-0.28-1.95-0.43-3.01-0.43h-6.22v13.81h6.78 c2.14,0,3.87-0.61,5.2-1.8c1.33-1.21,1.98-2.94,1.98-5.23C1368,543.06,1367.79,542.06,1367.4,541.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1377.34,571.21v-35.87h17.22v2.05h-15.17v13.06h15.17v2.22h-15.17v16.47h15.17v2.05h-17.22V571.21z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 370.35,
    cy: 118.06,
    r: 0,
    gradientTransform: "matrix(1 0 0 -1 0 660)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3DEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2311,
    style: {
      stopColor: "#F3DEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3816,
    style: {
      stopColor: "#E5C6A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5799,
    style: {
      stopColor: "#D5A983"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7632,
    style: {
      stopColor: "#A57B5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8977,
    style: {
      stopColor: "#D5A983"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.35,541.94"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000004534522663474124550000005059716899570486200_",
    cx: 286.5407,
    cy: 364.051,
    r: 394.4774,
    gradientTransform: "matrix(0.8799 0.4752 0.4367 -0.8085 -110.2982 452.8253)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0996,
    style: {
      stopColor: "#F3DEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2311,
    style: {
      stopColor: "#F3DEBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3816,
    style: {
      stopColor: "#E5C6A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5799,
    style: {
      stopColor: "#D5A983"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7632,
    style: {
      stopColor: "#A57B5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    style: {
      stopColor: "#D5A983"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004534522663474124550000005059716899570486200_)"
    },
    d: "M540.09,555.39 c-5.43-5.87-10.73-13.57-15.64-22.02c-4.12-7.51-7.65-15.37-11.3-23.16c-19.01-40.69-38.04-81.37-57.06-122.05 c-24.4-52.19-48.81-104.38-73.22-156.57l0.13-0.13c-23.39-50.02-46.79-100.05-70.18-150.07c-9.79-20.94-19.59-41.88-29.79-63.69 c-5.03,13.19-9.97,25.52-14.44,38.02c-5.83,16.31-7.07,33.04-4.26,50.2c2.41,14.74,9.07,27.75,15.28,41 c7.57,16.15,28.42,61.19,31.39,67.53c27.12,57.9,54.23,115.8,81.34,173.7c8.73,18.65,17.47,37.3,26.2,55.95 c11.99,25.62,24.26,51.11,35.69,76.98c2.93,6.63,6.44,14.65,4.38,21.77c-0.5,1.73-1.92,5.05-3.61,5.57 c-0.18,0.06-0.39,0.07-0.61,0.07c-8.97-11.63-14.83-25.03-21.02-38.28c-19.01-40.69-38.04-81.37-57.06-122.05 c-37.29-79.75-74.58-159.49-111.88-239.24c-9.79-20.94-19.59-41.88-29.79-63.69c-5.03,13.19-9.97,25.52-14.44,38.02 c-5.83,16.31-7.07,33.04-4.26,50.2c2.41,14.74,9.07,27.75,15.28,41c27.12,57.9,54.23,115.8,81.34,173.7 c8.73,18.65,17.47,37.3,26.2,55.95c4.92,10.52,9.89,21.01,14.83,31.52l0.07-0.02c7.03,14.97,14,29.96,20.68,45.08 c2.93,6.63,6.44,14.65,4.38,21.77c-0.5,1.73-1.92,5.05-3.61,5.57c-0.18,0.06-0.39,0.07-0.61,0.07 c-8.97-11.63-14.83-25.03-21.02-38.28c-4.68-10.01-9.36-20.01-14.03-30.01l0.06-0.02c-14.43-30.54-28.84-61.08-43.25-91.63 c-25.6-54.27-51.18-108.55-76.78-162.82c-6.3-13.35-12.7-26.64-19.46-40.8c-3.59,9.25-6.59,17.71-10.11,25.94 c-4.05,9.46-6.78,18.87-8.21,28.24v-0.02l-3.19,10.34c-12.35,31.39-27.36,69.13-42.36,106.22c-4.17,10.68-8.48,21.66-12.91,32.9 c-15.93,40.43-33.51,84.45-52.53,131.62c-9.81,22.43-18.36,47.12-39.26,47.14v4.74c15.08,0,25.24,0,36.92,0 c8.88,0,18.23,0,31.78,0v-4.74c-13.62-0.2-21.92-8.3-24.66-15.16c-2.89-7.23-2.89-13.14-2.89-17.35c0-6.07,2.31-12.29,5.12-19.3 c6.08-16.36,21.5-53.75,37.86-96.28c1.4,0,3.27,0,4.67,0c35.06,0,54.22,32.72,71.05,73.38c5.61,13.56,12.15,26.18,19.63,37.86 c14.4,23.22,32.95,41.35,63.9,41.59l-0.02,0.01l100.28-0.21c2.55,0.01,5.1,0.02,7.66,0.02h0.45c16.12,0,32.62,0.08,49-0.02l0,0 h137.92v-5.06C563.27,566.39,547.61,563.51,540.09,555.39z M298.81,541.74c0,7.95-2.8,24.77-23.37,24.77 c-45.81,0-64.03-42.53-80.39-78.53c-11.68-26.17-23.83-52.35-44.4-65.9c-9.35-5.61-19.63-8.41-30.85-8.41c-0.47,0-1.4,0-1.87,0 c3.24-8.48,6.62-16.97,10.06-25.52c3-7.47,6.05-14.99,9.1-22.62c16.94-42.15,34.5-87.01,43.5-109.1 c0.41,15.29,4.4,30.47,12.04,45.62l23.65,50.68l10.56,22.63l5.97,12.79c0,0,50.47,100.99,63.56,136.22 C299.18,531.93,298.81,538.04,298.81,541.74z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1e8744697884e56ac49fa5b9d74d1912.svg";
export { ForwardRef as ReactComponent };